import {I18n} from '@aws-amplify/core';
import {DataTableColumn} from 'mantine-datatable';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {SubscriptionItem} from '../types';

// FNP-918: was `tables/columns.tsx` — a bare `getColumns()` array where EVERY
// column was `render`-only, with no `accessor` on any of them.
//
// That is the distinction that made this module unsortable. `render` controls
// how a cell LOOKS; `accessor` is what sorting sorts BY. A render-only config
// looks complete in review and makes sorting structurally impossible (§3z).
//
// ⚠️ The old Created column rendered `item.created?.toString()` — the RAW
// Stripe epoch, so the cell read "1700000000" rather than a date. It is now
// formatted through the shared formatter, and sorts on the normalised millis.
export const useSubscriptionItemsTableColumns = () => {

    const columns: DataTableColumn<SubscriptionItem>[] = [
        {
            accessor: 'id',
            sortable: true,
            title: I18n.get('Subscription Item'),
            width: '1fr',
            render: (item: SubscriptionItem) => item.id,
        },
        {
            accessor: 'price',
            sortable: true,
            title: I18n.get('Price'),
            width: '1fr',
            // Nullable fields render the em-dash placeholder, never blank or
            // `undefined` (§13).
            render: (item: SubscriptionItem) => item.price ?? '—',
        },
        {
            accessor: 'quantity',
            sortable: true,
            title: I18n.get('Quantity'),
            width: '1fr',
            render: (item: SubscriptionItem) => item.quantity ?? '—',
        },
        {
            // Sorts on the normalised millisecond value so the ordering matches
            // what the cell displays. `created` (seconds) is still the source.
            accessor: 'createdAtMillis',
            sortable: true,
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: SubscriptionItem) => formatTimestamp(item.createdAtMillis),
        },
    ];

    return {columns};
};
